import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { loadToken } from '../localStorage';

const LoginRoute = ({ children, ...rest }) => {
  const token = loadToken();

  return (
    <Route
      {...rest}
      render={() => {
        return !token ? children : <Redirect to='/abonnements'></Redirect>;
      }}
    ></Route>
  );
};
export default LoginRoute;
